<template>
  <v-simple-table
    :height="tableHeight"
    fixed-header
  >
    <template v-slot:default>
      <thead>
        <tr>
          <th v-for="(header, index) in headers" :key="index" :colspan="header.colspan || 1">
            {{ header.text }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in tableData.data_compare" :key="rowIndex">
          <td
            v-for="(cell, cellIndex) in row"
            :key="cellIndex"
            :rowspan="cell.rowspan || 1"
            :colspan="cell.colspan || 1"
            :style="getCellStyle(cell)"
            @click="openEditDialog('data_compare', rowIndex, cellIndex, cell)"
            style="cursor: pointer;"
          >
            {{ cell.value.startsWith("__") ? "" : cell.value }}
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: 'TaskResultDataCompare',
  props: {
    tableHeight: {
      type: String,
      required: true
    },
    tableData: {
      type: Object,
      required: true
    },
    getCellStyle: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      headers: [
        { text: '', colspan: 2 },
        { text: 'Invoice', colspan: 2 },
        { text: 'Packing', colspan: 2 },
        { text: 'Bill Lading', colspan: 2 },
        { text: 'Match?', colspan: 1 }
      ],
    }
  },
  methods: {
    openEditDialog(tableType, groupIndex, cellIndex, cell) {
      this.$emit('open-edit-dialog', tableType, groupIndex, cellIndex, cell)
    }
  }
}
</script>

<style scoped>
:deep(.v-data-table__wrapper table th) {
  text-align: center !important;
}
td {
  border: 1px solid #ddd;
  padding: 8px;
}
td[style*="background-color"] {
  color: #fff;
}
:deep(.v-data-table__wrapper table) {
  border-collapse: collapse;
}
</style>
